<template>
  <div class="js-basedata-cargroup app-container">
    <!-- 查询 -->
    <app-search>
      <div slot="content">
        <el-row :gutter="10" type="flex" justify="start" align="middle">
          <el-col :span="6">
            <el-form
              :label-position="'right'"
              :model="listQuery"
              :label-width="$t('appManagement.width1')"
            >
              <el-form-item :label="$t('public.mobile')+'：'">
                <el-input
                  v-model="listQuery.mobile"
                  filterable
                  clearable
                  :placeholder="$t('public.mobile')"
                />
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="6">
            <el-form
              :label-position="'right'"
              :model="listQuery"
              :label-width="$t('appManagement.width1')"
            >
              <el-form-item :label="$t('appManagement.realName')+'：'">
                <el-input
                  v-model="listQuery.realName"
                  filterable
                  clearable
                  :placeholder="$t('appManagement.realName')"
                />
              </el-form-item>
            </el-form>
          </el-col>
          <el-col :span="8">
            <el-form
              :label-position="'right'"
              :model="listQuery"
              :label-width="$t('appManagement.width1')"
            >
              <el-form-item :label="$t('appManagement.status')+'：'">
                <el-radio-group v-model="listQuery.isDisabled">
                  <el-radio label>{{ $t('appManagement.all') }}</el-radio>
                  <el-radio :label="0">{{ $t('appManagement.enable') }}</el-radio>
                  <el-radio :label="1">{{ $t('appManagement.disable') }}</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
        <el-row
          v-show="collapse"
          style="margin-top:10px"
          :gutter="10"
          type="flex"
          justify="start"
          align="middle"
        >
          <el-col :span="12">
            <el-form
              :label-position="'right'"
              :model="listQuery"
              :label-width="$t('appManagement.width1')"
            >
              <el-form-item :label="$t('carMonitor.electric.electricManage.creattime')+'：'">
                <el-row type="flex" justify="start" align="middle">
                  <el-col :span="12">
                    <el-date-picker
                      v-model="listQuery.beginTime"
                      filterable
                      clearable
                      :placeholder="$t('public.startTime')"
                      type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      prefix-icon="el-icon-date"
                    />
                  </el-col>&emsp;
                  <span class="time-span" style="color:#ddd;">——</span>&emsp;
                  <el-col :span="12">
                    <el-date-picker
                      v-model="listQuery.endTime"
                      filterable
                      clearable
                      :placeholder="$t('public.endTime')"
                      type="datetime"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      prefix-icon="el-icon-date"
                    />
                  </el-col>
                </el-row>
              </el-form-item>
            </el-form>
          </el-col>
        </el-row>
      </div>
      <app-search-button
        slot="bottom"
        @click-collapse="handleCollapse"
        @click-filter="handleFilter"
        @click-clear="handleClear"
      />
    </app-search>
    <!-- 按钮 -->
    <app-authorize-button
      :data="authouizeList"
      @click-filter="showfilter=true"
      @click-export="handleExport"
    >
      <checked-Filter
        slot="check-filter"
        :show.sync="showfilter"
        :list="tableList"
        :scroll-line="8"
      />
    </app-authorize-button>
    <!-- table -->
    <el-table
      v-loading="listLoading"
      size="mini"
      :data="list"
      :max-height="tableHeight"
      border
      fit
      highlight-current-row
      style="width: 100%"
      :header-row-style="headerRowStyle"
      :row-style="rowStyle"
      :header-cell-style="headerCellStyle"
      :cell-style="cellStyle"
      @sort-change="sortChange"
      @row-click="rowClick"
    >
      <el-table-column :label="$t('table.id')" align="center" width="65">
        <template slot-scope="scope">
          <span>{{ (scope.$index+1)+(listQuery.pageNum -1)*listQuery.pageSize }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item,index) in filterTableList"
        :key="index"
        :label="item.value"
        :prop="item.prop"
        :align="item.position"
        :min-width="item.width"
        :sortable="item.sortable"
      >
        <template slot-scope="scope">
          <div v-if="item.prop==='isDisabled'">
            <span
              :class="scope.row[item.prop]===1?'errors':'defaults'"
              style="cursor:pointer;text-decoration:underline"
            >{{ scope.row[item.prop] | switchText(item.prop) }}</span>
          </div>
          <div v-else-if="item.prop==='playconnectAgree' || item.prop==='a2Agree'">
            <span
              :class="scope.row[item.prop]===0?'errors':'defaults'"
            >{{ scope.row[item.prop] | switchText(item.prop) }}</span>
          </div>
          <div v-else>{{ scope.row[item.prop] ||  (scope.row[item.prop]===0?scope.row[item.prop]: '/') }}</div>
        </template>
      </el-table-column>
      <el-table-column fixed="right" :label="$t('public.operation')" width="220px" align="center">
        <template slot-scope="scope">
          <!-- 如果需要特性化显示可使用v-if，v-else-if，v-else-->
          <div>
            <el-button
              type="primary"
              size="mini"
              @click="handleAudit(scope.row)"
            >{{ $t('public.view') }}</el-button>
            <el-button
              type="primary"
              size="mini"
              @click="restPasswrod(scope.row)"
            >{{ $t('appManagement.restPassword') }}</el-button>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div :class="[total>0?'visible':'hidden','pagination-container']">
      <el-pagination
        :current-page="listQuery.pageNum"
        :page-sizes="[10,20,30,50]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <!-- 规则明细dialog弹窗 -->
    <detail-dialog :visibles.sync="detailVisible" :data="tableRow" />
  </div>
</template>

<script>
// 混入
import { partialForm } from "@/mixins/partialForm"
import { pagingMixin } from "@/mixins/table"
import { otherHeight } from "@/mixins/getOtherHeight"
import { tableStyle } from "@/mixins/tableStyle"
import { getPageButton } from "@/mixins/getButton"
import detailDialog from "./components/detailDialog"
// request
import {
  getPagelist,
  resetStatus,
  exprotHandle,
  resetPassword
} from "@/api/userCenter/appManagement"
export default {
  name: "appUserManagement",
  filters: {
    switchText(val, type) {
      if (type === "isDisabled") {
        return val == 1
          ? vm.$t("system.user.ban")
          : vm.$t("system.user.enable")
      }else if(type === "playconnectAgree" || type === "a2Agree"){
        return val == 1
          ? vm.$t("system.pdpa.ty")
          : vm.$t("system.pdpa.bty")
      } else {
        return val
      }
    }
  },
  components: { detailDialog },
  mixins: [pagingMixin, partialForm, otherHeight, tableStyle, getPageButton],
  data() {
    return {
      detailVisible: false,
      listQuery: {
        isDisabled: ""
      },
      showfilter: false,
      tableList: [
        {
          value: this.$t("public.mobile"),
          prop: "mobile",
          position: "center",
          width: 100,
          sortable: "custom",
          checked: true
        },
        {
          value: this.$t("appManagement.realName"),
          prop: "realName",
          position: "center",
          width: 100,
          sortable: "custom",
          checked: true
        },
        {
          value: this.$t("appManagement.nickName"),
          prop: "nickName",
          position: "center",
          width: 100,
          sortable: "custom",
          checked: true
        },
        {
          value: this.$t("appManagement.status"),
          prop: "isDisabled",
          position: "center",
          width: 90,
          sortable: "custom",
          checked: true
        },
        // { value: vm.$t('appManagement.loginTime'), prop: 'loginTime', position: 'center', width: 90, sortable: 'custom', checked: false },
        {
          value: this.$t("appManagement.createdOn"),
          prop: "createdOn",
          position: "center",
          width: 120,
          sortable: "custom",
          checked: true
        },
        {
          value: this.$t("system.pdpa.playCtyzt"),
          prop: "playconnectAgree",
          position: "center",
          width: 200,
          sortable: "custom",
          checked: true
        },
        {
          value: this.$t("system.pdpa.playCversion"),
          prop: "playconnectVersion",
          position: "center",
          width: 160,
          sortable: "custom",
          checked: true
        },
        {
          value: this.$t("system.pdpa.playCtime"),
          prop: "playconnectAgreeTime",
          position: "center",
          width: 200,
          sortable: "custom",
          checked: true
        },
        {
          value: this.$t("system.pdpa.v2xtyzt"),
          prop: "a2Agree",
          position: "center",
          width: 160,
          sortable: "custom",
          checked: true
        },
        {
          value: this.$t("system.pdpa.v2xversion"),
          prop: "a2Version",
          position: "center",
          width: 160,
          sortable: "custom",
          checked: true
        },
        {
          value: this.$t("system.pdpa.v2xtime"),
          prop: "a2AgreeTime",
          position: "center",
          width: 160,
          sortable: "custom",
          checked: true
        }
      ],
      tableHeight: 0,
      total: 0,
      list: [],
      listLoading: false,
      tableRow: {}
    }
  },
  computed: {
    filterTableList() {
      return this.tableList.filter(item => item.checked)
    }
  },
  mounted() {},
  methods: {
    cellStyle(row) {
      if (row.column.label === this.tableList[3].value) {
        return { cursor: "pointer" }
      }
    },
    // 点击列
    rowClick(row, column) {
      const label = column.label
      this.tableRow = row
      const postData = {}
      if (label === this.$t("appManagement.status")) {
        postData.isDisabled = row.isDisabled
        postData.statusvalue = row.isDisabled
        postData.statustype = 0
        this._restStatus(postData)
      }
    },
    _restStatus(postData) {
      let confimText
      let url = ""
      if (postData.isDisabled == 1) {
        confimText = this.$t("system.user.enable")
        url = `/appUser/enable/${this.tableRow.appUserId}`
        this.$confirm(
          `${confimText}${this.tableRow.mobile}?`,
          this.$t("public.tips"),
          {
            confirmButtonText: this.$t("public.define"),
            cancelButtonText: this.$t("public.cancel"),
            type: "warning"
          }
        ).then(() => {
          resetStatus(url).then(({ data }) => {
            if (data.code === 0) {
              this.tableRow.isDisabled = this.tableRow.isDisabled === 0 ? 1 : 0
            }
          })
        }).catch(()=>{})
      } else {
        confimText = this.$t("system.user.ban")
        url = `/appUser/disable/${this.tableRow.appUserId}`
        this.$prompt(this.$t('carManagement.noComments'), this.$t('system.user.banTips'), {
        confirmButtonText: this.$t('public.define'),
        cancelButtonText: this.$t('public.cancel'),
        // inputPattern: /\+/,
        inputErrorMessage: this.$t('carManagement.errorComments'),
        inputValidator(v) {
          if (v && v.length > 250) return false
          return true
        }
      }).then(({ value }) => {
        const obj = {}
        obj.remark = value
        resetStatus(url,obj).then(({ data }) => {
            if (data.code === 0) {
              this.tableRow.isDisabled = this.tableRow.isDisabled === 0 ? 1 : 0
            }
          })
        
      }).catch(() => {})
        
      }
    },
    // 加载数据
    listLoad() {
      this.listLoading = true
      getPagelist(this.listQuery).then(({ data }) => {
        this.list = []
        if (data.code === 0) {
          this.list = data.data || []
          this.total = data.total
        }
        this.listLoading = false
      }).catch(()=>{
         this.listLoading = false
      })
    },
    // 导出
    handleExport() {
      exprotHandle(this.listQuery)
    },
    // 查看
    handleAudit(row) {
      this.tableRow = row
      this.detailVisible = true
    },
    // 重置密码
    restPasswrod() {
      this.$confirm(
        this.$t("appManagement.restPwd.msg1"),
        this.$t("public.tips"),
        {
          confirmButtonText: this.$t("public.define"),
          cancelButtonText: this.$t("public.cancel"),
          type: "warning"
        }
      )
        .then(() => {
          resetPassword(this.tableRow.appUserId).then(({ data }) => {
            if (data.code === 0) {
              this.$message.success({
                message: this.$t("appManagement.restPwd.updatePwdSuccess"),
                duration: 2 * 1000
              })
            }
          })
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang='scss'>
.set-input-padding input {
  padding-right: 10px !important;
}
</style>
